import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

function Breadcrumb({ paths }) {
    const navigate = useNavigate();
    function handleClick(event, url) {
        event.preventDefault(url);
        navigate(url);
    }
    return (
        <Box paddingBottom={2}>
            <Breadcrumbs separator={<NavigateNext />} aria-label="breadcrumb">
                <Link
                    underline="hover"
                    onClick={(e) => handleClick(e, '/')}
                    sx={{ display: 'flex', alignItems: 'center' }}
                    color={'primary'}
                    href={'/'}
                >
                    {t('home')}
                </Link>{' '}
                {paths.map((path, index) => (
                    <Link
                        underline="hover"
                        onClick={(e) => handleClick(e, path.url)}
                        sx={{ display: 'flex', alignItems: 'center' }}
                        color={index !== paths.length - 1 ? 'primary' : 'inherit'}
                        key={index}
                        href={path.url}
                    >
                        {path.label}
                    </Link>
                ))}
            </Breadcrumbs>
        </Box>
    );
}

export default Breadcrumb;
